var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinterLevel6MRDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 76,
    viewBox: "0 0 105 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.110928 52.3087L0.0929527 58.2035C0.0929527 58.2035 -0.805641 61.7979 4.13662 63.1457C9.07889 64.4936 4.58592 63.1457 4.58592 63.1457L45.9212 74.8275C45.9212 74.8275 50.4142 76.6246 54.0086 75.7261L54.4579 64.9429L20.7606 45.6232L0.110928 52.3087Z",
    fill: "#B7AE9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.431 49.6132C103.431 49.6671 103.881 55.9572 103.881 55.9572C103.881 55.9572 104.779 59.5516 102.533 60.8995C102.533 60.8995 61.6468 74.3784 61.1975 74.3784C60.7482 74.3784 56.2553 75.277 54.0088 75.7263V62.2474L103.431 49.6132Z",
    fill: "#A69F91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26826 48.71C7.26826 48.71 -7.43722 52.6324 5.2644 54.5913L45.3776 65.0464C45.3776 65.0464 53.8244 69.2519 63.7628 64.395C64.4323 64.067 100.533 51.9764 100.533 51.9764C100.533 51.9764 107.888 49.3615 99.1944 46.4231L60.4201 33.681C60.4201 33.681 54.404 31.7221 48.7204 34.6605L7.27276 48.71H7.26826Z",
    fill: "#D4C9B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.604 49.4781C18.604 49.4781 7.3985 52.731 17.1393 54.1283L47.952 61.8922C47.952 61.8922 54.4623 65.1002 62.0105 61.1643C62.5182 60.8993 89.9972 50.9743 89.9972 50.9743C89.9972 50.9743 95.591 48.8312 88.9099 46.6206L59.0901 37.0461C59.0901 37.0461 54.4623 35.5724 50.1491 37.9537L18.604 49.4826V49.4781Z",
    fill: "#C8BEAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6795 19.1507L33.9117 18.4588C33.3905 16.5313 33.5074 6.05818 33.9746 5.24046C38.5709 4.80464 65.3311 6.56588 65.5422 6.57936C65.7534 6.59283 66.2117 18.0814 66.2117 18.0814C66.2117 18.0814 48.8329 55.8223 48.6936 55.8133C48.5543 55.8043 35.9291 54.0161 33.3276 51.6169L50.6795 19.1507Z",
    fill: "#C8BEAE",
    stroke: "#C8BEAE",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6795 19.1507L33.9117 18.4588C33.3905 16.5313 33.5074 6.05818 33.9746 5.24046C38.5709 4.80464 65.3311 6.56588 65.5422 6.57936C65.7534 6.59283 66.2117 18.0814 66.2117 18.0814C66.2117 18.0814 48.8329 55.8223 48.6936 55.8133C48.5543 55.8043 35.9291 54.0161 33.3276 51.6169L50.6795 19.1507Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterLevel6MRDefault);
export default __webpack_public_path__ + "static/media/winter_level_6_m_r_default.ec87fc284f14df4646684f401dfe6bb4.svg";
export { ForwardRef as ReactComponent };